import { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import { Modal, Button } from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import * as jsonpatch from "fast-json-patch";
import * as endpoints from "constants/endpoints";
import { CreateItem } from "../../helpers/CRUD.js";
import { str2bool } from "../../helpers/utils.js";
import i18next from "i18next";

const ModalHeatingSeasons = (props) => {
  const initial_state = {
    document: {
      name: "",
      fromYear: "",
      toYear: "",
      isLocked: false,
    },
  };

  const [state, setState] = useState(initial_state);

  const resetData = () => {
    setState(initial_state);
  };

  const toggleIsLocked = (e) => {
    const document = state.document;
    document.isLocked = str2bool(e.target.value);

    setState((state) => ({ ...state, document }));
  };

  const handleValidSubmit = (event, values) => {
    let patch = jsonpatch.compare(initial_state.document, state.document);

    const url = `${endpoints.NOMENCLATURE_ENDPOINT}/HeatingSeason/Add`;

    CreateItem(
      url,
      patch,
      (data) => {
        update();
        props.emitSuccess(i18next.t("entry_added_successfully"));
      },
      (error) => {
        props.emitErrors(error);
      }
    );
  };

  const closeModal = () => {
    props.closeModal();
    resetData();
  };

  const update = () => {
    props.update();
    resetData();
  };

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Modal isOpen={props.isModalOpen} scrollable={true}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">
                {i18next.t("modal_heating_season_title")}
              </h5>

              <button
                type="button"
                onClick={() => closeModal()}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <Card className="mb-0">
                <CardBody>
                  <AvForm
                    onValidSubmit={handleValidSubmit}
                    className="needs-validation"
                  >
                    <Row className="mb-4">
                      <Col md="12">
                        <FormGroup>
                          <Label htmlFor="name">{i18next.t("name")}</Label>

                          <AvField
                            name="document.name"
                            placeholder={i18next.t("placeholder_enter_name")}
                            id="name"
                            onChange={(e) =>
                              setState((state) => ({
                                ...state,
                                document: {
                                  ...state.document,
                                  name: e.target.value,
                                },
                              }))
                            }
                            defaultValue={state.document.name}
                            className="w-100"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Col md="12">
                        <FormGroup>
                          <Label htmlFor="fromYear">
                            {i18next.t("fromYear")}
                          </Label>

                          <AvField
                            type="number"
                            min={1990}
                            max={2099}
                            name="document.fromYear"
                            placeholder={i18next.t("placeholder_enter_year")}
                            id="fromYear"
                            onChange={(e) =>
                              setState((state) => ({
                                ...state,
                                document: {
                                  ...state.document,
                                  fromYear: e.target.value,
                                },
                              }))
                            }
                            defaultValue={state.document.fromYear}
                            className="w-100"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Col md="12">
                        <FormGroup>
                          <Label htmlFor="toYear">{i18next.t("toYear")}</Label>

                          <AvField
                            type="number"
                            min={1990}
                            max={2099}
                            name="document.toYear"
                            placeholder={i18next.t("placeholder_enter_year")}
                            id="toYear"
                            onChange={(e) =>
                              setState((state) => ({
                                ...state,
                                document: {
                                  ...state.document,
                                  toYear: e.target.value,
                                },
                              }))
                            }
                            defaultValue={state.document.toYear}
                            className="w-100"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Col md="12">
                        <div className="form_controls">
                          <label>{i18next.t("locked")}</label>

                          <div>
                            <div className="radio">
                              <label>
                                <input
                                  type="radio"
                                  value="true"
                                  checked={state.document.isLocked === true}
                                  onChange={(e) => toggleIsLocked(e)}
                                />
                                {i18next.t("yes")}
                              </label>
                            </div>

                            <div className="radio">
                              <label>
                                <input
                                  type="radio"
                                  value="false"
                                  checked={state.document.isLocked === false}
                                  onChange={(e) => toggleIsLocked(e)}
                                />
                                {i18next.t("no")}
                              </label>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => closeModal()}
                      >
                        <i className="fa fa-times mr-1" />
                        {i18next.t("button_cancel")}
                      </button>

                      <Button color="primary" type="submit">
                        <i className="fa fa-plus-circle mr-1" />
                        {i18next.t("button_add")}
                      </Button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </div>
          </Modal>
        </Container>
      </div>
    </>
  );
};

ModalHeatingSeasons.propTypes = {
  users: PropTypes.array,
  onGetUsers: PropTypes.func,
};

const mapStateToProps = ({ contacts }) => ({
  users: contacts.users,
});

const mapDispatchToProps = (dispatch) => ({
  onGetUsers: () => dispatch(getUsers()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ModalHeatingSeasons));
